import { COAL_AUXILLIARY_VIEW, COAL_AUXILLIARY_EDIT } from '@/fixtures'

export default {
  path: 'bup-coal-auxilliary',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Coal Auxiliary',
      component: () => import('@/views/menus/CoalAuxiliary/Index'),
      meta: {
        permission: COAL_AUXILLIARY_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Coal Auxiliary',
      component: () => import('@/views/menus/CoalAuxiliary/Detail'),
      meta: {
        permission: COAL_AUXILLIARY_VIEW,
        isEdit: false
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Coal Auxiliary',
      component: () => import('@/views/menus/CoalAuxiliary/Detail'),
      meta: {
        permission: COAL_AUXILLIARY_EDIT,
        isEdit: true
      }
    }
  ]
}
